/**
 * Normalizes an array of select options to a standard format of `{ value, label, disabled, icon }` objects.
 * Supports `{ value, label }`, `{ value, text }`, and `{ value, name }` shapes.
 *
 * @param {Array<any>} options - The raw array of options or primitive values.
 * @returns {Array<{ value: any, label: string, disabled: boolean, icon: React.ReactNode }>} The normalized options array.
 */
export const normalizeOptions = (options) => {
  if (!options) return [];
  return options.map((option) => {
    if (option && typeof option === "object") {
      const label =
        option.label !== undefined
          ? option.label
          : option.text !== undefined
          ? option.text
          : option.name !== undefined
          ? option.name
          : String(option.value);
      return {
        value: option.value,
        label,
        disabled: !!option.disabled,
        icon: option.icon,
      };
    }
    return {
      value: option,
      label: String(option),
      disabled: false,
      icon: undefined,
    };
  });
};
